// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","246":"72caa4f2","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"4a162e9728fa1445a124","246":"fc655198dd2b7c452bd5","532":"c0223dee8d3d0da489e1","691":"7e12ee3dc0dafe907352"}[chunkId] + ".js";
};